import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MSGraphService } from '../../services/msgraph.service';

@Pipe({
  name: 'userImage',
  standalone: true
})
export class UserImagePipe implements PipeTransform {
  private urlCache = new Map<string, string>();

  constructor(private graphService: MSGraphService) {}

  transform(email: string): Observable<string> {
    if (this.urlCache.has(email)) {
      return of(this.urlCache.get(email)!);
    }

    return this.graphService.getUserPhoto$(email).pipe(
      map((blob) => {
        const url = URL.createObjectURL(blob);
        this.urlCache.set(email, url);
        return url;
      }),
      catchError(() => of('/assets/images/default-avatar.jpg'))
    );
  }

  ngOnDestroy() {
    this.urlCache.forEach((url) => URL.revokeObjectURL(url));
    this.urlCache.clear();
  }
}
